/**
 * Turn a `redirect_url` query value into a safe in-app path, or `fallback`.
 *
 * Only same-origin targets are honoured (relative paths, or absolute URLs on
 * this origin from older links), so the param can't be used as an open
 * redirect. The auth pages themselves are rejected to avoid bouncing loops.
 */
export function safeRedirectPath(raw: string | null | undefined, fallback = '/'): string {
  if (!raw) return fallback;
  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin) return fallback;
    if (url.pathname.startsWith('//')) return fallback;
    if (url.pathname === '/sign-in' || url.pathname === '/sign-up') return fallback;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return fallback;
  }
}

/**
 * `/sign-in` or `/sign-up` carrying the post-auth destination along, if any,
 * plus an email to prefill (e.g. the address an invitation was sent to).
 */
export function authPageHref(page: '/sign-in' | '/sign-up', redirectPath: string, email?: string | null): string {
  const qs = new URLSearchParams();
  if (redirectPath !== '/') qs.set('redirect_url', redirectPath);
  if (email) qs.set('email', email);
  const q = qs.toString();
  return q ? `${page}?${q}` : page;
}
